// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../../reason/clients/components/Labels.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var RentalNeedStatus_rentalNeedV5_graphql = require("../../../__generated__/RentalNeedStatus_rentalNeedV5_graphql.bs.js");

var convertFragment = RentalNeedStatus_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedStatus_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedStatus_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, RentalNeedStatus_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedStatus_rentalNeedV5_graphql.node, convertFragment, fRef);
}

var RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalNeed__Status$WithoutErrorBoundary(props) {
  var rentalNeed = use(props.rentalNeed);
  var s = rentalNeed.status;
  switch (s.__typename) {
    case "ActiveRentalNeed" :
        return null;
    case "ExpiredRentalNeed" :
        return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "RemovedRentalNeed" :
        return JsxRuntime.jsx(Labels.RemovedLabel.make, {});
    case "RentedRentalNeed" :
        return JsxRuntime.jsx(Labels.PurchasedLabel.make, {});
    case "WithdrawnRentalNeed" :
        return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
        return UnselectedUnionMemberError.raise("Unselected rental need status " + s._0);
    
  }
}

var WithoutErrorBoundary = {
  make: RentalNeed__Status$WithoutErrorBoundary
};

function RentalNeed__Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "rental need status",
              children: JsxRuntime.jsx(RentalNeed__Status$WithoutErrorBoundary, {
                    rentalNeed: props.rentalNeed
                  })
            });
}

var make = RentalNeed__Status;

exports.RentalNeedFragment = RentalNeedFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
